import Api2Talk from '../api2talk';

export const getCustomerPhoneSyncStatus = (chatId) =>
  Api2Talk.get(`customer/phone-sync/status/${chatId}`).then(response => response.data);

export const synchronizeCustomerPhone = (chatId, direction) =>
  Api2Talk.put('customer/phone-sync', { chatid: chatId, direction }).then(response => response.data);

export const associateCustomerUser = (chat) =>
  Api2Talk.put('customer/syncdata', {
    id: chat && chat.customer ? chat.customer.id : 0,
    chatid: chat ? chat.id : 0,
    name: chat && chat.customer ? chat.customer.name : '',
    email: chat && chat.customer ? chat.customer.email : '',
    phone: chat && chat.customer ? chat.customer.phone : ''
  }).then(response => response.data);
